import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function cancelUserSubscription(subscriptionId, message) {
  return axios
    .patch(`${BASE_URL}/subscription/${subscriptionId}`, {
      isCancel: true,
      reason: message,
    })
    .then(({ data }) => data);
}

export function revertCancellation(subscriptionId) {
  return axios
    .patch(`${BASE_URL}/subscription/${subscriptionId}`, {
      revertCancellation: true,
      id: subscriptionId,
    })
    .then(({ data }) => data);
}

export function cancelScheduleOnSwitchIosToStripe() {
  return axios
    .post(`${BASE_URL}/subscription/cancelScheduleOnSwitchIosToStripe`)
    .then(({ data }) => data);
}

export function switchSubscriptionToStripe(switchSubscription) {
  return axios
    .post(
      `${BASE_URL}/subscription/switchSubscriptionToStripe`,
      switchSubscription,
    )
    .then(({ data }) => data);
}

export function renewSubscription(newSubscription) {
  return axios
    .post(`${BASE_URL}/subscription/renew`, newSubscription)
    .then(({ data }) => data);
}

export function changePlan(id, subscription) {
  return axios
    .patch(`${BASE_URL}/subscription/${id}`, subscription)
    .then(({ data }) => data);
}

export function activateSubscription() {
  return axios
    .post(`${BASE_URL}/subscription/activateSubscription`, {})
    .then(({ data }) => data);
}

export async function updateSubscriptionPlan(planId) {
  return axios
    .post(`${BASE_URL}/subscription/updateSubscriptionPlan`, { planId })
    .then(({ data }) => data);
}

export function upgradeAccount(
  dutyState,
  rank,
  rate,
  stripeToken,
  tax,
  planId,
) {
  return axios
    .patch(`${BASE_URL}/upgradeAccount`, {
      dutyState,
      rank,
      rate,
      tax,
      planId,
      stripeToken,
    })
    .then(({ data }) => data);
}
